import { initContract } from "@ts-rest/core";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    OrganizationTaskTemplateBulkBodySchema,
    OrganizationTaskTemplateBulkResponseSchema,
    OrganizationTaskTemplateCreateSchema,
    OrganizationTaskTemplateIdParamsSchema,
    OrganizationTaskTemplateListQuerySchema,
    OrganizationTaskTemplateListResponseSchema,
    OrganizationTaskTemplatePathParamsSchema,
    OrganizationTaskTemplateUpdateSchema,
} from "@common/schemas/organization-task-template.schema";
import { OrganizationTaskTemplateSchema } from "@common/types/organizationTaskTemplate";

export {
    OrganizationTaskTemplateCreateSchema,
    OrganizationTaskTemplateUpdateSchema,
};
export type {
    OrganizationTaskTemplateCreate,
    OrganizationTaskTemplateUpdate,
} from "@common/schemas/organization-task-template.schema";

const c = initContract();

const templatePathParams = OrganizationTaskTemplatePathParamsSchema.merge(
    OrganizationTaskTemplateIdParamsSchema,
);

export const organizationTaskTemplateContract = c.router(
    {
        listOrganizationTaskTemplates: {
            method: "GET",
            path: "/organizations/:organizationId",
            pathParams: OrganizationTaskTemplatePathParamsSchema,
            query: OrganizationTaskTemplateListQuerySchema,
            responses: {
                200: OrganizationTaskTemplateListResponseSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        getOrganizationTaskTemplate: {
            method: "GET",
            path: "/organizations/:organizationId/:templateId",
            pathParams: templatePathParams,
            responses: {
                200: OrganizationTaskTemplateSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        createOrganizationTaskTemplate: {
            method: "POST",
            path: "/organizations/:organizationId",
            pathParams: OrganizationTaskTemplatePathParamsSchema,
            body: OrganizationTaskTemplateCreateSchema,
            responses: {
                201: OrganizationTaskTemplateSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        updateOrganizationTaskTemplate: {
            method: "PATCH",
            path: "/organizations/:organizationId/:templateId",
            pathParams: templatePathParams,
            body: OrganizationTaskTemplateUpdateSchema,
            responses: {
                200: OrganizationTaskTemplateSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
                409: ErrorMessageSchema,
            },
        },
        archiveOrganizationTaskTemplate: {
            method: "POST",
            path: "/organizations/:organizationId/:templateId/archive",
            pathParams: templatePathParams,
            body: c.noBody(),
            responses: {
                200: OrganizationTaskTemplateSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        unarchiveOrganizationTaskTemplate: {
            method: "POST",
            path: "/organizations/:organizationId/:templateId/unarchive",
            pathParams: templatePathParams,
            body: c.noBody(),
            responses: {
                200: OrganizationTaskTemplateSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        deleteOrganizationTaskTemplate: {
            method: "DELETE",
            path: "/organizations/:organizationId/:templateId",
            pathParams: templatePathParams,
            responses: {
                200: c.noBody(),
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        detachOrganizationTaskTemplate: {
            method: "POST",
            path: "/organizations/:organizationId/:templateId/detach",
            pathParams: templatePathParams,
            body: c.noBody(),
            responses: {
                200: OrganizationTaskTemplateBulkResponseSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        bulkArchiveOrganizationTaskTemplates: {
            method: "POST",
            path: "/organizations/:organizationId/bulk-archive",
            pathParams: OrganizationTaskTemplatePathParamsSchema,
            body: OrganizationTaskTemplateBulkBodySchema,
            responses: {
                200: OrganizationTaskTemplateBulkResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        bulkUnarchiveOrganizationTaskTemplates: {
            method: "POST",
            path: "/organizations/:organizationId/bulk-unarchive",
            pathParams: OrganizationTaskTemplatePathParamsSchema,
            body: OrganizationTaskTemplateBulkBodySchema,
            responses: {
                200: OrganizationTaskTemplateBulkResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        bulkDetachOrganizationTaskTemplates: {
            method: "POST",
            path: "/organizations/:organizationId/bulk-detach",
            pathParams: OrganizationTaskTemplatePathParamsSchema,
            body: OrganizationTaskTemplateBulkBodySchema,
            responses: {
                200: OrganizationTaskTemplateBulkResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        bulkDeleteOrganizationTaskTemplates: {
            method: "POST",
            path: "/organizations/:organizationId/bulk-delete",
            pathParams: OrganizationTaskTemplatePathParamsSchema,
            body: OrganizationTaskTemplateBulkBodySchema,
            responses: {
                200: OrganizationTaskTemplateBulkResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/organization-task-templates",
    },
);
